// extracted by mini-css-extract-plugin
module.exports = {"icon":"SelectCompany_icon__3PSW5","control":"SelectCompany_control__CVTwy","arrow":"SelectCompany_arrow__vABxh","visible":"SelectCompany_visible__1qt4I"};